import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

/**
 * One data source the insights agent can read, plus whether it is actually
 * wired into the agent's toolset. `reachable: false` means the data exists but
 * no tool exposes it, so the model cannot see it however good the content is.
 */
export const patientAgentInputSchema = z.object({
  key: z.string(),
  label: z.string(),
  toolName: z.string().nullable(),
  reachable: z.boolean(),
  count: z.number().int(),
  /** Verbatim tool payload, so the page shows what the model actually gets. */
  records: z.array(z.unknown()),
});

export const patientAgentInputsSchema = z.object({
  patientId: z.string(),
  sources: z.array(patientAgentInputSchema),
});

export type PatientAgentInput = z.infer<typeof patientAgentInputSchema>;
export type PatientAgentInputs = z.infer<typeof patientAgentInputsSchema>;

export const patientAgentInputsContract = c.router(
  {
    get: {
      method: 'GET',
      path: '/:patientId',
      pathParams: z.object({
        tenantId: z.string(),
        patientId: z.string(),
      }),
      responses: {
        200: patientAgentInputsSchema,
        404: z.object({ message: z.string() }),
      },
      summary:
        "Every patient data source the insights agent can draw on, with the payload each tool returns and whether a tool exposes it at all. Exists because medication_requests has no Hasura permissions and the artifact tabs read different tables than the agent does — so there was previously no way to see the model's actual inputs.",
    },
  },
  { pathPrefix: '/:tenantId/patient-agent-inputs' },
);
